<template>
  <div class="home-cy-page">
    <!-- 深蓝背景光晕 -->
    <div class="glow-bg">
      <div class="glow-orb glow-orb-1"></div>
      <div class="glow-orb glow-orb-2"></div>
      <div class="glow-orb glow-orb-3"></div>
    </div>

    <!-- 粒子画布 -->
    <canvas ref="particleCanvas" class="particle-canvas"></canvas>

    <!-- 主容器 -->
    <div class="main-container">
      <!-- 顶部标题区 -->
      <header class="header-section fade-in">
        <div class="corner-decoration corner-tl"></div>
        <div class="corner-decoration corner-tr"></div>
        <div class="corner-decoration corner-bl"></div>
        <div class="corner-decoration corner-br"></div>

        <div class="header-inner">
          <div class="header-text-area">
            <img src="../assets/logo-chaokao.png" class="header-logo" alt="朝考通logo" />
            <div class="header-title-group">
              <h1 class="header-title">
                <span class="highlight">朝考通</span><span class="title-separator"> — </span><span class="title-sub">朝阳区人事考试考务智能指挥调度一体化平台</span>
              </h1>
              <p class="header-subtitle">CHAOYANG DISTRICT PERSONNEL EXAMINATION INTELLIGENT COMMAND PLATFORM</p>
            </div>
          </div>

          <div class="status-panel">
            <div class="status-item">
              <div class="status-dot"></div>
              <span class="status-text">当前考试：北京市朝阳区2026年度上半年事业单位公开招聘笔试</span>
            </div>
            <!-- 安全防护已启用 tag 已隐藏 -->
          </div>
        </div>
      </header>

      <!-- 导航网格 -->
      <div class="nav-grid">
        <!-- 卡片 1 -->
        <div class="tech-card fade-in delay-1" @click="$router.push('/index?p=cy&username=北京市朝阳区考试测评中心')">
          <div class="card-header">
            <div class="card-icon-box">
              <svg class="card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
              </svg>
            </div>
            <span class="card-number">01</span>
          </div>
          <h3 class="card-title">考务视频指挥调度</h3>
          <p class="card-desc">打造朝阳区人事考试"会前、会中、会后"的全流程、轻量级"考试视频指挥调度" 应用服务，实现考试全过程可视化监管、应急事件实时动态指挥调度、试卷收发场景全覆盖的安全管控和事后的可追溯，全面确保各项人事考试安全、平稳、顺利。</p>
          <div class="card-footer">
            <div class="enter-btn">
              <span>进入系统</span>
              <svg class="icon-sm arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </div>
            <span class="tag">视频调度</span>
          </div>
        </div>

        <!-- 卡片 2 -->
        <div class="tech-card fade-in delay-2" @click="$router.push('/location-trace?p=cy')">
          <div class="card-header">
            <div class="card-icon-box">
              <svg class="card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
            </div>
            <span class="card-number">02</span>
          </div>
          <h3 class="card-title">试卷北斗定位及视频循迹</h3>
          <p class="card-desc">基于北斗卫星定位技术，全程追踪试卷流转轨迹，视频记录每一个环节，确保试卷运输安全可控。</p>
          <div class="card-footer">
            <div class="enter-btn">
              <span>进入系统</span>
              <svg class="icon-sm arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </div>
            <span class="tag">试卷安全</span>
          </div>
        </div>

        <!-- 卡片 3 -->
        <!-- <div class="tech-card fade-in delay-3" @click="openExternal('http://81.70.251.55:9091/?p=cy')"> -->
        <div class="tech-card fade-in delay-3" @click="openExternal('https://kw.smartsq.net/')">
          <div class="card-header">
            <div class="card-icon-box">
              <svg class="card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
              </svg>
            </div>
            <span class="card-number">03</span>
          </div>
          <h3 class="card-title">考务管理一体化</h3>
          <p class="card-desc">集"考点管理、考务人员管理、考务人员培训、考务人员报名、考点分配、考务人员老带新（智能分配组合）以及考务预算管理"等主要管理环节的支撑应用为一体，实现全过程考务管理。</p>
          <div class="card-footer">
            <div class="enter-btn">
              <span>进入系统</span>
              <svg class="icon-sm arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </div>
            <span class="tag">朝考通</span>
          </div>
        </div>

        <!-- 卡片 4 -->
        <!-- <div class="tech-card fade-in delay-4" @click="$router.push('/platform?p=cy')"> -->
        <div class="tech-card fade-in delay-4" @click="$router.push('/bigscreen_cy?p=cy')">
          
          <div class="card-header">
            <div class="card-icon-box">
              <svg class="card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
            </div>
            <span class="card-number">04</span>
          </div>
          <h3 class="card-title">考务数据分析及精准布防</h3>
          <p class="card-desc">实现对朝阳区人事考试数据的整合及动态分析，大数据分析考务规律，智能预测风险点，实现精准化布防策略，为考务安全决策提供数据支撑。</p>
          <div class="card-footer">
            <div class="enter-btn">
              <span>进入系统</span>
              <svg class="icon-sm arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </div>
            <span class="tag">数据分析</span>
          </div>
        </div>

        <!-- 卡片 5 -->
        <div class="tech-card fade-in delay-5" @click="$router.push('/page_img01')">
          <div class="card-header">
            <div class="card-icon-box">
              <svg class="card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <span class="card-number">05</span>
          </div>
          <h3 class="card-title">考生服务应用</h3>
          <p class="card-desc">打造朝阳区人事考务服务品牌，通过"移动端应用"将考生服务前置，在各考点设置考生服务海报，考生可以通过扫描二维码的方式"提意见、报问题"。</p>
          <div class="card-footer">
            <div class="enter-btn">
              <span>进入系统</span>
              <svg class="icon-sm arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </div>
            <span class="tag">考生服务</span>
          </div>
        </div>

        <!-- 卡片 6 -->
        <div class="tech-card fade-in delay-6" @click="$router.push('/video-play?p=cy')">
          <div class="card-header">
            <div class="card-icon-box">
              <svg class="card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
              </svg>
            </div>
            <span class="card-number">06</span>
          </div>
          <h3 class="card-title">考务指挥调度全流程展示</h3>
          <p class="card-desc">可视化展示考务全流程节点，实时掌握各环节进度与状态，实现全流程透明化管理与监控。</p>
          <div class="card-footer">
            <div class="enter-btn">
              <span>进入系统</span>
              <svg class="icon-sm arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </div>
            <span class="tag">全场景覆盖</span>
          </div>
        </div>
      </div>

      <!-- 底部 -->
      <footer class="footer-section">
        <p class="footer-text">"朝考通"朝阳区人事考试考务智能指挥调度一体化平台 · 版本 2.0.1</p>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeCy',
  data() {
    return {
      currentTime: '',
      clockTimer: null,
      animationFrameId: null,
      particles: [],
      canvasWidth: 0,
      canvasHeight: 0
    };
  },
  mounted() {
    // 如果 URL 带有 ?p=cy，标记 cy 模式（供目标页感知）
    if (this.$route.query.p === 'cy') {
      sessionStorage.setItem('cy_mode', '1');
    }
    this.startClock();
    this.initParticles();
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    if (this.clockTimer) clearInterval(this.clockTimer);
    if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    // ---------- 时钟 ----------
    startClock() {
      this.updateClock();
      this.clockTimer = setInterval(this.updateClock, 1000);
    },
    updateClock() {
      const now = new Date();
      const timeStr = now.toLocaleTimeString('zh-CN', { hour12: false });
      const dateStr = now
        .toLocaleDateString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' })
        .replace(/\//g, '.');
      this.currentTime = dateStr + ' ' + timeStr;
    },

    // ---------- 粒子 ----------
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      this.canvasWidth = canvas.width = window.innerWidth;
      this.canvasHeight = canvas.height = window.innerHeight;
      this.createParticles();
      this.animateParticles();
    },
    createParticles() {
      this.particles = [];
      const count = Math.floor((this.canvasWidth * this.canvasHeight) / 15000);
      for (let i = 0; i < count; i++) {
        this.particles.push({
          x: Math.random() * this.canvasWidth,
          y: Math.random() * this.canvasHeight,
          size: Math.random() * 2 + 0.5,
          speedX: (Math.random() - 0.5) * 0.3,
          speedY: (Math.random() - 0.5) * 0.3,
          opacity: Math.random() * 0.4 + 0.1,
          color: Math.random() > 0.6 ? '#60a5fa' : '#3b82f6'
        });
      }
    },
    animateParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      const W = this.canvasWidth;
      const H = this.canvasHeight;

      ctx.clearRect(0, 0, W, H);

      this.particles.forEach(p => {
        p.x += p.speedX;
        p.y += p.speedY;
        if (p.x < 0 || p.x > W) p.speedX *= -1;
        if (p.y < 0 || p.y > H) p.speedY *= -1;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.globalAlpha = p.opacity;
        ctx.fill();
      });

      // 连线
      ctx.globalAlpha = 0.06;
      ctx.strokeStyle = '#60a5fa';
      ctx.lineWidth = 0.5;
      for (let i = 0; i < this.particles.length; i++) {
        for (let j = i + 1; j < this.particles.length; j++) {
          const dx = this.particles[i].x - this.particles[j].x;
          const dy = this.particles[i].y - this.particles[j].y;
          if (Math.sqrt(dx * dx + dy * dy) < 150) {
            ctx.beginPath();
            ctx.moveTo(this.particles[i].x, this.particles[i].y);
            ctx.lineTo(this.particles[j].x, this.particles[j].y);
            ctx.stroke();
          }
        }
      }
      ctx.globalAlpha = 1;

      this.animationFrameId = requestAnimationFrame(this.animateParticles);
    },
    onResize() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      this.canvasWidth = canvas.width = window.innerWidth;
      this.canvasHeight = canvas.height = window.innerHeight;
      this.createParticles();
    },
    openExternal(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>
/* ===== 根容器 ===== */
.home-cy-page {
  position: relative;
  font-family: 'Noto Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background: linear-gradient(135deg, #020617 0%, #0a1628 50%, #07132a 100%);
  color: #e0f2fe;
  overflow-x: hidden;
  min-height: 100vh;
}

/* ===== 深蓝背景光晕 ===== */
.glow-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.2;
  animation: cy-float 25s infinite ease-in-out;
}

.glow-orb-1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(30, 64, 175, 0.5), transparent 70%);
  top: -200px;
  left: 20%;
  animation-delay: 0s;
}

.glow-orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(37, 99, 235, 0.4), transparent 70%);
  bottom: -100px;
  right: 10%;
  animation-delay: -8s;
}

.glow-orb-3 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.3), transparent 70%);
  top: 40%;
  left: 60%;
  animation-delay: -16s;
}

@keyframes cy-float {
  0%,  100% { transform: translate(0, 0) scale(1); }
  33%        { transform: translate(20px, -20px) scale(1.05); }
  66%        { transform: translate(-15px, 15px) scale(0.95); }
}

/* ===== 粒子画布 ===== */
.particle-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

/* ===== 主容器 ===== */
.main-container {
  position: relative;
  z-index: 10;
  padding: 20px;
  max-width: 1920px;
  margin: 0 auto;
}

@media (max-width: 1440px) {
  .main-container {
    padding: 15px;
  }
}

@media (max-width: 1366px) {
  .main-container {
    padding: 12px;
  }
}

/* ===== 顶部标题区 ===== */
.header-section {
  position: relative;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.8), rgba(30, 58, 138, 0.4));
  backdrop-filter: blur(20px);
  border: 1px solid rgba(59, 130, 246, 0.25);
  border-radius: 12px;
  padding: 28px 35px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  overflow: hidden;
  min-height: 140px;
  box-sizing: border-box;
}

@media (max-width: 1440px) {
  .header-section {
    padding: 22px 28px;
    margin-bottom: 24px;
    min-height: 140px;
  }
}

@media (max-width: 1366px) {
  .header-section {
    padding: 18px 24px;
    margin-bottom: 20px;
    min-height: 120px;
  }
}

.header-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #3b82f6, #60a5fa, #3b82f6, transparent);
  animation: cy-gradient-flow 4s ease infinite;
}

@keyframes cy-gradient-flow {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.header-inner {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 1600px) {
  .header-inner {
    gap: 16px;
  }
}

.header-text-area {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  text-align: left;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.header-title-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex: 1;
  min-height: 80px;
  overflow: hidden;
}

.header-title {
  font-size: 2rem;
  font-weight: 900;
  color: #ffffff;
  letter-spacing: 2px;
  text-shadow: 0 0 20px rgba(59, 130, 246, 0.5);
  line-height: 1.35;
  margin: 0;
}

.title-separator {
  white-space: pre;
}

.title-sub {
  word-break: normal;
  overflow-wrap: break-word;
}

@media (max-width: 1600px) {
  .header-title { font-size: 1.7rem; }
}

@media (max-width: 1440px) {
  .header-title { font-size: 1.5rem; }
}

@media (max-width: 1366px) {
  .header-title { font-size: 1.35rem; letter-spacing: 1px; }
}

.header-logo {
  /* height: 56px; */
  /* width: 200px; */
  /* width: auto; */
  width: 100px;
  height: 100px;
  /* object-fit: contain; */
  position: relative;
  left: -10px;
  flex-shrink: 0;
  filter: drop-shadow(0 0 8px rgba(59, 130, 246, 0.4));
}

@media (max-width: 1440px) {
  .header-logo { height: 48px; }
}

@media (max-width: 1366px) {
  .header-logo { height: 42px; }
}

.header-title .highlight {
  color: #60a5fa;
  font-weight: 900;
}

.header-subtitle {
  color: rgba(147, 197, 253, 0.7);
  font-size: 0.95rem;
  letter-spacing: 3px;
  margin-top: 6px;
  font-weight: 500;
}

@media (max-width: 1440px) {
  .header-subtitle {
    font-size: 0.85rem;
    letter-spacing: 2px;
  }
}

@media (max-width: 1366px) {
  .header-subtitle {
    font-size: 0.75rem;
    letter-spacing: 1px;
  }
}

/* 角标装饰 */
.corner-decoration {
  position: absolute;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(59, 130, 246, 0.4);
}
.corner-tl { top: 8px; left: 8px; border-right: none; border-bottom: none; }
.corner-tr { top: 8px; right: 8px; border-left: none; border-bottom: none; }
.corner-bl { bottom: 8px; left: 8px; border-right: none; border-top: none; }
.corner-br { bottom: 8px; right: 8px; border-left: none; border-top: none; }

/* ===== 状态面板 ===== */
.status-panel {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex-shrink: 0;
  /* max-width: 380px; */
}

.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(30, 58, 138, 0.3);
  border: 1px solid rgba(59, 130, 246, 0.2);
  padding: 6px 14px;
  border-radius: 8px;
  transition: all 0.3s;
}

@media (max-width: 1440px) {
  .status-item { padding: 5px 12px; }
}

@media (max-width: 1366px) {
  .status-item { padding: 4px 10px; }
}

.status-item:hover {
  background: rgba(30, 58, 138, 0.5);
  border-color: rgba(59, 130, 246, 0.4);
}

.status-dot {
  width: 8px;
  height: 8px;
  background: #22d3ee;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(34, 211, 238, 0.6);
  animation: cy-pulse 2s infinite;
  flex-shrink: 0;
}

@keyframes cy-pulse {
  0%,  100% { opacity: 1; transform: scale(1); }
  50%        { opacity: 0.6; transform: scale(1.2); }
}

.status-text {
  font-size: 0.8rem;
  color: rgba(191, 219, 254, 0.9);
  font-weight: 500;
}

@media (max-width: 1440px) {
  .status-text { font-size: 0.75rem; }
}

@media (max-width: 1366px) {
  .status-text { font-size: 0.7rem; }
}

.icon-sm {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.cyan {
  color: #22d3ee;
}

.time-display {
  font-size: 1rem;
  color: #67e8f9;
  font-weight: 700;
  letter-spacing: 1px;
  background: rgba(30, 58, 138, 0.3);
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid rgba(59, 130, 246, 0.2);
  white-space: nowrap;
}

@media (max-width: 1440px) {
  .time-display { font-size: 0.9rem; padding: 5px 12px; }
}

@media (max-width: 1366px) {
  .time-display { font-size: 0.85rem; padding: 4px 10px; }
}

/* ===== 导航网格 ===== */
.nav-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding: 0 10px;
}

@media (max-width: 1600px) {
  .nav-grid { gap: 20px; }
}

@media (max-width: 1440px) {
  .nav-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    padding: 0 8px;
  }
}

@media (max-width: 1366px) {
  .nav-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    padding: 0 6px;
  }
}

@media (max-width: 1200px) {
  .nav-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 768px) {
  .nav-grid { grid-template-columns: 1fr; }
  .header-title { font-size: 1.3rem; }
  .header-logo { height: 40px; }
  .header-text-area { gap: 10px; }
}

/* ===== 科技卡片 ===== */
.tech-card {
  position: relative;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.7), rgba(30, 58, 138, 0.3));
  backdrop-filter: blur(20px);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 12px;
  padding: 30px 24px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

@media (max-width: 1600px) {
  .tech-card { padding: 26px 20px; }
}

@media (max-width: 1440px) {
  .tech-card { padding: 22px 18px; }
}

@media (max-width: 1366px) {
  .tech-card { padding: 18px 16px; }
}

.tech-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.08), transparent);
  transition: left 0.6s;
}

.tech-card:hover::before {
  left: 100%;
}

.tech-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #2563eb, #60a5fa);
  transition: width 0.4s;
}

.tech-card:hover::after {
  width: 100%;
}

.tech-card:hover {
  border-color: rgba(59, 130, 246, 0.4);
  box-shadow: 0 15px 40px rgba(37, 99, 235, 0.2), inset 0 0 20px rgba(59, 130, 246, 0.05);
  transform: translateY(-6px);
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.8), rgba(30, 58, 138, 0.4));
}

/* 卡片内部布局 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 18px;
}

.card-icon-box {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, rgba(30, 58, 138, 0.4), rgba(59, 130, 246, 0.2));
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

@media (max-width: 1440px) {
  .card-icon-box {
    width: 50px;
    height: 50px;
    border-radius: 10px;
  }
}

@media (max-width: 1366px) {
  .card-icon-box {
    width: 44px;
    height: 44px;
    border-radius: 8px;
  }
}

.card-icon-box::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: conic-gradient(from 0deg, transparent, rgba(59, 130, 246, 0.2), transparent 30%);
  animation: cy-rotate 4s linear infinite;
}

@keyframes cy-rotate {
  100% { transform: rotate(360deg); }
}

.tech-card:hover .card-icon-box {
  background: linear-gradient(135deg, rgba(30, 58, 138, 0.5), rgba(59, 130, 246, 0.3));
  border-color: rgba(59, 130, 246, 0.5);
  transform: scale(1.05);
}

.card-icon {
  position: relative;
  z-index: 2;
  width: 26px;
  height: 26px;
  color: #60a5fa;
  transition: all 0.3s;
}

@media (max-width: 1440px) {
  .card-icon { width: 24px; height: 24px; }
}

@media (max-width: 1366px) {
  .card-icon { width: 22px; height: 22px; }
}

.tech-card:hover .card-icon {
  color: #93c5fd;
}

.card-number {
  font-size: 2rem;
  font-weight: 900;
  color: rgba(59, 130, 246, 0.15);
  line-height: 1;
  transition: all 0.3s;
}

@media (max-width: 1440px) {
  .card-number { font-size: 1.7rem; }
}

@media (max-width: 1366px) {
  .card-number { font-size: 1.5rem; }
}

.tech-card:hover .card-number {
  color: rgba(59, 130, 246, 0.25);
}

.card-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #f0f9ff;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
  transition: all 0.3s;
}

@media (max-width: 1440px) {
  .card-title { font-size: 1.05rem; }
}

@media (max-width: 1366px) {
  .card-title { font-size: 0.95rem; margin-bottom: 6px; }
}

.tech-card:hover .card-title {
  color: #93c5fd;
}

.card-desc {
  font-size: 0.85rem;
  color: rgba(147, 197, 253, 0.65);
  line-height: 1.6;
  margin-bottom: 18px;
}

@media (max-width: 1440px) {
  .card-desc {
    font-size: 0.8rem;
    line-height: 1.5;
    margin-bottom: 14px;
  }
}

@media (max-width: 1366px) {
  .card-desc {
    font-size: 0.75rem;
    line-height: 1.4;
    margin-bottom: 12px;
  }
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 14px;
  border-top: 1px solid rgba(59, 130, 246, 0.1);
}

@media (max-width: 1366px) {
  .card-footer { padding-top: 10px; }
}

.enter-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #60a5fa;
  font-size: 0.8rem;
  font-weight: 600;
  transition: all 0.3s;
}

@media (max-width: 1366px) {
  .enter-btn { font-size: 0.75rem; }
}

.tech-card:hover .enter-btn {
  color: #93c5fd;
  gap: 10px;
}

.arrow-icon {
  transition: transform 0.3s;
}

.tech-card:hover .arrow-icon {
  transform: translateX(4px);
}

.tag {
  font-size: 0.7rem;
  padding: 3px 8px;
  background: rgba(30, 58, 138, 0.3);
  border: 1px solid rgba(59, 130, 246, 0.25);
  color: #93c5fd;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s;
}

@media (max-width: 1366px) {
  .tag { font-size: 0.65rem; padding: 2px 6px; }
}

.tech-card:hover .tag {
  background: rgba(30, 58, 138, 0.4);
  border-color: rgba(59, 130, 246, 0.4);
}

/* ===== 底部 ===== */
.footer-section {
  margin-top: 40px;
  padding: 18px;
  text-align: center;
  border-top: 1px solid rgba(59, 130, 246, 0.1);
}

@media (max-width: 1440px) {
  .footer-section { margin-top: 30px; padding: 14px; }
}

@media (max-width: 1366px) {
  .footer-section { margin-top: 24px; padding: 12px; }
}

.footer-text {
  font-size: 0.8rem;
  color: rgba(100, 116, 139, 0.5);
  letter-spacing: 1px;
}

/* ===== 加载动画 ===== */
.fade-in {
  animation: cy-fade-in 0.8s ease-out forwards;
  opacity: 0;
}

@keyframes cy-fade-in {
  to { opacity: 1; }
}

.delay-1 { animation-delay: 0.1s; }
.delay-2 { animation-delay: 0.2s; }
.delay-3 { animation-delay: 0.3s; }
.delay-4 { animation-delay: 0.4s; }
.delay-5 { animation-delay: 0.5s; }
.delay-6 { animation-delay: 0.6s; }
</style>
